<template>
  <div class="common_custom_input_box">
    <div v-if="label">
      <label class="common_custom_input_title">{{ label }}</label>
    </div>
    <div class="common_custom_input_box my-1">
      <b-input-group @mouseover="hover(true)" @mouseout="hover(false)">
        <b-form-input ref="common_custom_input" class="common_custom_input"
                      @input="input"
                      autocomplete="off"
                      v-model="keyword"
                      size="sm"
                      :class="{active : isActive, hover: isHover}"
                      :placeholder="placeholder"
        />
        <b-input-group-append>
          <b-button class="common_custom_input_icon" size="sm" :class="{active : isActive, hover: isHover}"
                    @click="search">
            <i class="search"><img src="./icon_search.png" height="12" width="12"/></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>

<script>
/*
  ※주의 : 데이터 추가할때 주석부분에도 추가해주세요.※
  =================================================
  ※ prop data ※
  [label : String]
  [placeholder : String]
  =================================================
  ※ Event ※
  input => text값 입력시 event 발생.
  =================================================
  ※ EX ※
  <common-input
    :label="'입력'"
    :placeholder="'차량명, 차량번호'"
    @search="v => {this.searchWord = v, init()}"
  />
*/
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      keyword: null,
      isActive: false,
      isHover: false,
    }
  },
  mounted () {
    const el = this.$refs.common_custom_input.$el
    el.addEventListener('blur', this.blur)
  },
  methods: {
    blur (value) {
      if (value.target.value != null && value.target.value !== '') this.isActive = false, this.isHover = false
    },
    hover (isHover) {
      if (isHover) this.isHover = isHover
      else this.isHover = isHover
    },
    input (value) {
      if (value != null && value !== '') this.isActive = true, this.isHover = false
      else this.isActive = false
    },
    search () {
      this.$emit('search', this.keyword)
    }
  },
}
</script>

<style lang="scss" scoped>
$placeholderColor: #aaa;
$placeholderFontSize: 85%;
$hoverColor: #18A0FB;
$borderColor: #e5e5e5;

.common_custom_input_box {

}

.common_custom_input_title {
  color: #000000;
}

.common_custom_input {
  border: 1px solid $borderColor;
  border-right: 0px;
  box-shadow: none;

  &::placeholder {
    font-size: $placeholderFontSize;
    color: $placeholderColor;
    opacity: 1;
  }

  &::-webkit-input-placeholder {
    font-size: $placeholderFontSize;
    color: $placeholderColor;
  }

  &:-ms-input-placeholder {
    font-size: $placeholderFontSize;
    color: $placeholderColor;
  }

  &.hover {
    border-color: $hoverColor;
  }

  &.active {
    border: 1px solid $hoverColor !important;
  }
}

.common_custom_input_icon {
  font-size: 12px;
  height: 31px;
  color: #FFFFFF;
  background-color: #fff;
  border: 1px solid $borderColor;
  border-left: 0px;
  border-radius: 0px 4px 4px 0px;
  z-index: 0;
  box-shadow: none;

  &.hover {
    color: #FFFFFF;
    background-color: $hoverColor;
    border-color: $hoverColor;
    border-radius: 0px 4px 4px 0px;
  }

  &.active {
    margin-left: -1px;
    background-color: $hoverColor !important;
    border-color: $hoverColor !important;
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15px;
  }

  &:focus {
    box-shadow: none;
  }
}

</style>
